import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeleteMeasLaboratoryPrescriptionMutation as useChDeleteMeasLaboratoryPrescriptionMutationType } from "@/modules/patients/detail/meas-laboratory-prescription/ch/services/__generated__/useChDeleteMeasLaboratoryPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChDeleteMeasLaboratoryPrescriptionMutation($input: Ch_deleteMeasLaboratoryPrescriptionInput!) {
    ch_deleteMeasLaboratoryPrescription(input: $input) {
      ch_MeasLaboratoryPrescription {
        id @deleteRecord
      }
    }
  }
`

const useChDeleteMeasLaboratoryPrescriptionMutation = () => {
  const [commit, isFlight] = useMutation<useChDeleteMeasLaboratoryPrescriptionMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeleteMeasLaboratoryPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeleteMeasLaboratoryPrescriptionMutation }
